export enum ItemHighlightingMode {
  ENABLED = "Enabled",
  DISABLED = "Disabled"
}
